import { Add, Delete, Edit } from "@mui/icons-material";
import { AlertColor } from "@mui/material";
import {
    GridColDef,
    GridRenderCellParams,
    GridRowId,
    GridRowParams,
} from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import ButtonGeneric from "../../components/ButtonGeneric";
import { CompleteFilter } from "../../components/CompleteFilter";
import { applyClientFilters } from "../../components/CompleteFilter/applyClientFilters";
import ModalDeleteProfile, {
    DataProfileProps,
} from "../../components/DeleteProfileModal";
import { If } from "../../components/If";
import PageWrapper from "../../components/PageWrapper/index";
import TableDataGrid from "../../components/TableDataGrid";
import Toast from "../../components/Toast";
import { useAuth } from "../../contexts/contexts";
import { api } from "../../services/api";

function ProfilesPage() {
    const [loadingTable, setLoadingTable] = useState(true);
    const [queryFilter, setQueryFilter] = useState("");
    const [dataProfileList, setDataProfileList] = useState<DataProfileProps[]>(
        []
    );
    const navigate = useNavigate();
    const { hasPermissions, permissions } = useAuth();
    useEffect(() => {
        if (
            hasPermissions("perfil.listar") === false &&
            permissions.length > 0
        ) {
            navigate("/Error");
        }
    }, [permissions]);
    const [openDeleteProfileModal, setOpenDeleteProfileModal] = useState(false);
    const handleCloseDeleteProfileModal = () => {
        setOpenDeleteProfileModal(false);
    };
    const [selectedRowProfileId, setSelectedRowProfileId] =
        useState<GridRowId>();
    const [selectedRowProfileName, setSelectedRowProfileName] = useState("");
    // toast configs
    const [openToast, setOpenToast] = useState(false);
    function handleCloseToast() {
        setOpenToast(false);
    }
    const [toastRequisitionResult, setToastRequisitionResult] =
        useState<AlertColor>();
    const [textToast, setTextToast] = useState("");

    useEffect(() => {
        api.get("/roles/all")
            .then((response) => {
                setLoadingTable(false);

                if (response.data.status) {
                    setDataProfileList(response.data.response);
                }
            })
            .catch((error) => {
                setOpenToast(true);
                setToastRequisitionResult("error");
                setTextToast(error.response.data.message);
            });
    }, []);

    const filteredRows = applyClientFilters(
        dataProfileList as unknown as Record<string, unknown>[],
        queryFilter,
        { textFields: ["name"] }
    ) as unknown as DataProfileProps[];

    const columns: GridColDef[] = [
        { field: "id", headerName: "ID", flex: 5 },
        { field: "name", headerName: "Nome", flex: 65 },
        {
            field: "ações",
            headerName: "Ações",
            flex: 30,
            sortable: false,
            align: "right",
            headerAlign: "right",
            disableExport: true,
            renderCell: (params: GridRenderCellParams) => (
                <div className="containerActionButtonsListTablePagesGlobal">
                    <If condition={hasPermissions("perfil.editar")}>
                        <Edit
                            className="cursorPointerGlobal"
                            onClick={() => {
                                navigate(
                                    `/settings/profiles/profileEdit?id=${params.id}`
                                );
                            }}
                        />
                    </If>
                    <If condition={hasPermissions("perfil.excluir")}>
                        <Delete
                            className="cursorPointerGlobal"
                            onClick={() => {
                                setOpenDeleteProfileModal(true);
                            }}
                        />
                    </If>
                </div>
            ),
        },
    ];

    return (
        <>
            <PageWrapper>
                <div className="containerListTablePagesGlobal">
                    <CompleteFilter
                        fields={[{ value: "name", label: "Nome" }]}
                        onSearch={setQueryFilter}
                        actions={
                            <If condition={hasPermissions("perfil.cadastrar")}>
                                <ButtonGeneric
                                    onclick={() => {
                                        navigate(
                                            "/settings/profiles/profileRegister"
                                        );
                                    }}
                                    buttonColor="var(--primary)"
                                    text="Novo perfil"
                                    icon={<Add />}
                                />
                            </If>
                        }
                    />
                    <TableDataGrid
                        rows={filteredRows}
                        columns={columns}
                        onRowClick={(row: GridRowParams) => {
                            setSelectedRowProfileId(row.id);
                            setSelectedRowProfileName(row.row.name);
                        }}
                        loading={loadingTable}
                    />
                    <ModalDeleteProfile
                        openDeleteProfileModal={openDeleteProfileModal}
                        handleCloseDeleteProfileModal={
                            handleCloseDeleteProfileModal
                        }
                        selectedRowProfileId={selectedRowProfileId}
                        dataProfileList={dataProfileList}
                        setDataProfileList={setDataProfileList}
                        selectedRowProfileName={selectedRowProfileName}
                    />
                </div>
            </PageWrapper>
            <Toast
                open={openToast}
                onClose={() => handleCloseToast()}
                severity={toastRequisitionResult}
                text={textToast}
            />
        </>
    );
}
export default ProfilesPage;
